// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 16) return "static/js/9524633703a9c70dff80.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"95f9fb3b36b9e157476f","127":"df128ae1591e9d035e16","128":"8db1a7b4693986df61c5"}[chunkId] + ".chunk.js";
};